module.exports = __webpack_public_path__ + "img/img-cropper.a2ff611f.jpg";